module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0100.jpg?v=a1b42036";